import * as React from 'react'
import { FaIcon, faTruckClock } from '@/lib/fa'

/** Empty state listy aktywności — faTruckClock 40×40 px, treść wyśrodkowana. */
export const ActivitiesEmptyState = ({
  title,
  subtitle,
}: {
  title: string
  subtitle: string
}) => (
  <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-px-4 tw-pt-24 tw-pb-8">
    <div className="tw-flex tw-max-w-md tw-flex-col tw-items-center tw-gap-4 tw-text-center">
      <FaIcon
        icon={faTruckClock}
        className="tw-shrink-0 tw-text-[#A8D4E8] tw-opacity-[0.95]"
        style={{ width: 40, height: 40 }}
        aria-hidden
      />
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-2">
        <p className="tw-text-lg tw-font-bold tw-leading-snug tw-text-content-base">
          {title}
        </p>
        <p className="tw-text-sm tw-font-normal tw-leading-relaxed tw-text-[#97A2B3]">
          {subtitle}
        </p>
      </div>
    </div>
  </div>
)
